import { render, staticRenderFns } from "./CouponEditor.vue?vue&type=template&id=2ed22dac&scoped=true"
import script from "./CouponEditor.vue?vue&type=script&lang=js"
export * from "./CouponEditor.vue?vue&type=script&lang=js"
import style0 from "./CouponEditor.vue?vue&type=style&index=0&id=2ed22dac&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ed22dac",
  null
  
)

export default component.exports